import {NextRouter} from "next/router";
import {RemoveObjectKeys} from "@/base/utils/removeobjectkeys";
import {compareObjects} from "@/base/utils/compare.util";

export const ReplaceSaveProps = [
	'auth',
	'hash',
	'host',
	'hostname',
	'href',
	'pathname',
	'protocol',
	'search',
	'slashes',
	'port',
	'query'
];

export async function RefreshRoute(router: NextRouter, q = 'refresh', options: any = {scroll: false}) {
	return router.push({
		...router,
		query: {
			...router.query,
			[q]: `this_is_crouch_and_bogdan_eating_pizza_${Math.random()}`
		}
	}, undefined, options)
}

export async function ClearQueryParams(q: string[], router: NextRouter | null = null, shallow: boolean = true) {
	if (router != null)
	{
		const query = RemoveObjectKeys(router.query, q);
		if (compareObjects(router.query, query))
		{
			return false;
		}

		await router.replace({
			...(
				Object.keys(router).reduce((a, c) => {
					if (ReplaceSaveProps.includes(c))
					{
						a[c] = (router as any)[c];
					}
					return a
				}, {} as Record<string, any>)
			),
			query
		}, undefined, {
			shallow
		}).then(() => ClearQueryParams(q));

		return true;
	}
	else if (typeof window !== 'undefined')
	{
		const url = new URL(window.location.href);

		let deleteCount = 0;

		q.forEach((param) => {
			url.searchParams.delete(param);

			deleteCount++;
		});

		if (deleteCount === 0)
		{
			return false;
		}

		window.history.pushState({}, '', url.toString());

		return true;
	}
}